module.exports = "./images/mediboard-btn@2x.png?061f98a18ae10296f11df99830e9bd76";


//////////////////
// WEBPACK FOOTER
// ./src/images/mediboard-btn@2x.png
// module id = 166
// module chunks = 0